import { render } from "./GlobalAppSidebar.vue?vue&type=template&id=189ab8f3&scoped=true"
import script from "./GlobalAppSidebar.vue?vue&type=script&lang=js"
export * from "./GlobalAppSidebar.vue?vue&type=script&lang=js"

import "./GlobalAppSidebar.vue?vue&type=style&index=0&id=189ab8f3&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-189ab8f3"]])

export default __exports__